// extracted by mini-css-extract-plugin
export default {"button":"Button_button__OOMYT","primary":"Button_primary__8Xpxy","secondary":"Button_secondary__GBY7J"};